import { useEffect, useState } from "react";
import axios from "axios";
import { MailQuestion, WandSparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { API } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { ContactHero } from "@/components/contact/ContactHero";
import { ContactLeadForm } from "@/components/contact/ContactLeadForm";
import { DELIVERY_MESSAGE, INTERNATIONAL_ORDER_NOTE } from "@/lib/deliveryContent";

export default function Contact() {
  const [contact, setContact] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    const title = document.title;
    document.title = "Contact — Kandula Home Foods, Tanuku";
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    axios.get(`${API}/contact/whatsapp`).then(({ data }) => { if (active) setContact(data); }).catch(() => { if (active) setError(true); });
    return () => { active = false; document.title = title; };
  }, []);
  return (
    <div className="min-h-screen bg-cream font-body text-foreground" data-testid="contact-page">
      <Header />
      <main className="pt-16 sm:pt-[72px]">
        <ContactHero contact={contact} error={error} />
        <section className="mx-auto grid max-w-7xl gap-8 px-4 py-14 sm:px-8 sm:py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-testid="contact-actions-container">
          <div className="min-w-0">
            <MailQuestion className="mb-4 h-7 w-7 text-terracotta" aria-hidden="true" />
            <h2 className="font-display text-base font-semibold text-ragi-dark md:text-lg" data-testid="contact-form-title">Tell us what you have in mind.</h2>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground" data-testid="contact-form-intro">Millets for the week, treats for a celebration, or something made especially for you.</p>
            <p className="mt-5 text-sm font-semibold leading-relaxed text-ragi" data-testid="contact-delivery-message">{DELIVERY_MESSAGE}</p>
            <p className="mt-2 text-xs leading-relaxed text-muted-foreground" data-testid="contact-international-order-note">{INTERNATIONAL_ORDER_NOTE}</p>
            <Link to="/image-studio" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-terracotta underline-offset-4 transition-colors hover:underline" data-testid="contact-image-studio-link"><WandSparkles className="h-4 w-4 shrink-0" />Create a gift-box concept</Link>
          </div>
          <ContactLeadForm available={Boolean(contact)} />
        </section>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}